var _g, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-90 0 32)",
    fill: "#D9D2FE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-90 4 28)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.648 20.64C12.708 20.64 11.42 19.338 11.42 17.434V17.21H13.016V17.406C13.016 18.638 13.52 19.212 15.592 19.212C17.538 19.212 18.238 18.764 18.238 17.658C18.238 16.706 17.594 16.272 16.418 16.272H13.8V15.012H16.208C17.342 15.012 17.93 14.592 17.93 13.752C17.93 12.842 17.37 12.408 15.55 12.408C13.632 12.408 13.016 12.982 13.016 14.214V14.312H11.42V14.186C11.42 12.352 12.764 10.98 15.676 10.98C18.07 10.98 19.428 11.862 19.428 13.458C19.428 14.522 18.798 15.278 17.594 15.474V15.586C18.952 15.824 19.764 16.58 19.764 17.882C19.764 19.66 18.21 20.64 15.648 20.64Z",
    fill: "#523FC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveThree);
export default __webpack_public_path__ + "static/media/active-three.8c5ef9e065e08a6151133597a9884c4f.svg";
export { ForwardRef as ReactComponent };